<template>
  <YapButtonIcon :loading="state.downloading" @click="handleDownload(fileResource)">
    <YapIcon name="download-outline" class="h-6 w-6" />
  </YapButtonIcon>
</template>

<script setup lang="ts">
import { reactive } from 'vue';

import apiGw from '@/services/apiGw';
import { downloadFile } from '@/utils/file';
import YapIcon from '@/components/YapIcon.vue';
import { FileResource } from '@/types/fileResource';
import YapButtonIcon from '@/components/YapButtonIcon.vue';

const props = defineProps<{
  fileResource: FileResource;
}>();

interface State {
  downloading: boolean;
}

const state: State = reactive({
  downloading: false
});

async function handleDownload(fileResource: FileResource) {
  state.downloading = true;
  const bucketFileName = fileResource.bucketFileName ?? fileResource.bucketUid;
  const response = await apiGw.get(`/files/${bucketFileName}/raw`, { responseType: 'arraybuffer' });
  const content = response.data;
  const contentType = response.headers['content-type'];
  const filename = fileResource.displayName;
  downloadFile(content, filename, contentType);
  state.downloading = false;
}
</script>
